import styles from "./Tabs.module.css";

export default function Tabs({ tabs, activeTab, setActiveTab, unseenCount }) {
  return (
    <div className={styles.TabsContainer}>
      {tabs.map((tab) => {
        return (
          <div key={tab.id}>
            <div
              onClick={() => setActiveTab(tab.key)}
              className={`${styles.Tab} ${
                tab.key === activeTab ? styles.Active : ""
              }`}
            >
              {tab.label}
              {tab.key === "UNREAD" && (
                <p className={styles.unseenCount}>{unseenCount}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
